import { call } from 'redux-saga/effects';
import { QueryContext } from 'services/utils/QueryContext';

import {
  getVulnerabilityPrioritizationFlow,
  PrioritizationFlow,
  PrioritizationFlowParams,
} from 'api/scan-vault/prioritizationFlow';

export function* doGetPrioritizationFlow(
  ctx: QueryContext<PrioritizationFlow, PrioritizationFlowParams>,
) {
  yield call(ctx.fetch, () => getVulnerabilityPrioritizationFlow(ctx.params), {
    // The client returns the response body itself, not an Axios response;
    // QueryContext.fetch would otherwise store `body.data` (undefined).
    map: value => value,
    errorMsg: 'Failed to get vulnerability prioritization data!',
  });
}
